import { apiFetch } from './client';

// Public payment page client — no auth, the token in the URL is the
// credential (D-8). Only safe-to-expose fields are returned.

export interface PublicInvoiceLine {
  description: string;
  quantity_milli: number;
  unit_amount_minor: number;
  vat_rate_bp: number;
  line_total_minor: number;
  line_vat_minor: number;
}

export interface PublicInvoice {
  number: string;
  ocr_reference: string;
  status: 'issued' | 'partially_paid' | 'paid' | 'overdue';
  currency: string;
  issue_date: string;
  due_date: string;
  customer_name: string;
  org_name: string;
  org_logo_object_key: string;
  org_primary_color: string;
  subtotal_minor: number;
  vat_minor: number;
  total_minor: number;
  amount_paid_minor: number;
  amount_refunded_minor: number;
  lines: PublicInvoiceLine[];
}

export async function getPublicInvoice(token: string): Promise<PublicInvoice> {
  return apiFetch<PublicInvoice>(`/api/v1/public/billing/invoices/${encodeURIComponent(token)}`);
}

export async function startPublicCheckout(
  token: string,
  successURL: string,
  cancelURL: string,
): Promise<{ url: string }> {
  return apiFetch<{ url: string }>(
    `/api/v1/public/billing/invoices/${encodeURIComponent(token)}/checkout`,
    { method: 'POST', body: { success_url: successURL, cancel_url: cancelURL } },
  );
}

export interface SwishStart {
  swish_qr: string;
  swish_deep_link: string;
}

// startSwishPayment issues a Swish payment request for the invoice's balance.
// Returns the QR payload (scan on another device) + a swish:// deep link
// (same-device). Rejects with a 503 (code "swish_not_configured") when the
// club hasn't enabled Swish — the caller hides the option and keeps card.
export async function startSwishPayment(token: string): Promise<SwishStart> {
  return apiFetch<SwishStart>(
    `/api/v1/public/billing/invoices/${encodeURIComponent(token)}/swish`,
    { method: 'POST' },
  );
}
